<template>
  <div>
    <!-------------loader start---------------->
    <div>
      <loader-component :loader="loader" />
    </div>
    <!------------loader end----------------->
    <v-row class="ma-0 pa-0" style="height: 100vh">
      <v-col md="5" class="ma-0 pa-0">
        <div class="d-flex justify-center pa-14">
          <div>
            <v-card flat class="pa-1 d-flex justify-center">
              <img
                width="150"
                src="../../../assets//images/bodytalk-logo-flat.svg"
              />
            </v-card>
            <!----- ------start ----Section Account or emial aleardy registered----------------->
            <div v-show="EmaiAleardyRegisterd">
              <div class="d-flex justify-center mt-10 mb-4">
                <h1>Welcome to the IBA Team</h1>
              </div>
              <div class="d-flex justify-center">
                <span class="span_two"> {{ form.email }}</span>
              </div>
              <div class="d-flex justify-center mt-5">
                <span class="span_two">User is aleardy registerd </span>
              </div>
              <div class="d-flex justify-center mt-5">
                <v-btn depressed color="primary" to="/login">
                  <span class="text_style"> Go to Login</span></v-btn
                >
              </div>
            </div>
            <!----- ------end ----Section Account or emial aleardy registered----------------->
            <!----- ------start ----Section for URL is not valid----------------->
            <div v-show="InvalidUrl">
              <div class="d-flex justify-center mt-10 mb-4">
                <h1>Welcome to the IBA Team</h1>
              </div>
              <div class="d-flex justify-center"></div>
              <div class="d-flex justify-center mt-5">
                <span class="span_two"
                  >Sorry... your token is invalid or has expired
                </span>
              </div>
            </div>
            <!----- ------end ----Section for URL is not valid----------------->
            <!----- ------start ----Section for register new user----------------->
            <div v-show="NewRegisterdUser">
              <div class="d-flex justify-center mt-10 mb-4">
                <h1>Welcome to the IBA Team</h1>
              </div>
              <div class="d-flex justify-center">
                <span class="span_one"
                  >Welcome! You have been invited to create an IBA Admin account
                </span>
              </div>
              <div class="d-flex justify-center">
                <span class="span_two">{{ form.email }}</span>
              </div>
              <div class="d-flex justify-center px-14 mt-9 pb-2">
                <v-card color="transparent" flat width="200">
                  <registerimageuploader-component
                    @SetImage="SetImage"
                    @SetImageFile="SetImageFile"
                  />
                </v-card>
              </div>
              <div class="d-flex justify-center mt-11">
                <form @submit.prevent="submit" style="width: 100%">
                  <div
                    class="form-group pt-1"
                    :class="{ 'form-group--error': $v.form.firstName.$error }"
                  >
                    <v-text-field
                      v-model="form.firstName"
                      hide-details=""
                      dense
                      label="First name"
                      :error="$v.form.firstName.$error"
                      single-line
                    ></v-text-field>
                    <div style="color: red" v-if="$v.form.firstName.$error">
                      First name is required
                    </div>
                  </div>
                  <div
                    class="form-group pt-1"
                    :class="{ 'form-group--error': $v.form.lastname.$error }"
                  >
                    <v-text-field
                      v-model="form.lastname"
                      hide-details=""
                      dense
                      label="Last name"
                      :error="$v.form.lastname.$error"
                      single-line
                    ></v-text-field>
                    <div class="error" v-if="$v.form.lastname.$error">
                      Last name is required
                    </div>
                  </div>
                  <div
                    class="form-group pt-1 mb-0"
                    :class="{ 'form-group--error': $v.form.password.$error }"
                  >
                    <v-text-field
                      single-line
                      dense
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      label="Password"
                      value="Password"
                      name="input-10-2"
                      hide-details=""
                      v-model="form.password"
                      :error="$v.form.password.$error"
                      class="input-group--focused"
                      @click:append="show1 = !show1"
                    ></v-text-field>
                    <div class="error" v-if="$v.form.password.$error">
                      Password is required
                    </div>
                    <div class="error--text" v-if="!$v.form.password.minLength">
                      <span class="password_limit_error">
                        Use {{ $v.form.password.$params.minLength.min }} or more
                        characters with a mix of letter and numbers.
                      </span>
                    </div>
                  </div>
                  <!-- <div class="d-flex justify-end mt-5">
                    <a
                      ><router-link to="/login">
                        Do you already have an IBA account?</router-link
                      ></a
                    >
                  </div> -->
                  <v-btn
                    class="button mt-14"
                    block
                    height="60"
                    color="#00AAD3"
                    type="submit"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span class="text_style" style="color: white"
                      >JOIN IBA ADMIN</span
                    >
                  </v-btn>
                  <v-dialog
                    v-model="registerscreen2dialog"
                    persistent
                    max-width="520"
                  >
                    <v-card
                      class="pt-4 pb-9 px-9"
                      flat
                      color="#E5E5E5"
                      style="border-radius: 10px"
                    >
                      <v-card-title class="d-flex justify-center"
                        ><svg
                          width="168"
                          height="43"
                          viewBox="0 0 168 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M38.5687 16.2399C38.6893 16.5214 38.8021 16.8029 38.9149 17.0844C40.2104 15.239 40.8818 13.4353 40.7664 11.8557C38.466 7.747 34.8873 4.49024 30.5671 2.57383C30.4425 3.34619 30.17 4.08766 29.7646 4.75811C33.3969 7.50541 36.5178 11.4752 38.5687 16.2399ZM23.5464 10.6202C21.9131 11.6469 20.1984 12.5395 18.4192 13.2893C16.0597 14.3049 13.5904 15.0474 11.0602 15.5023C11.8272 18.7975 12.8693 22.0234 14.1758 25.1465C15.2814 25.0425 16.3958 25.0829 17.4908 25.2664C17.7338 25.3248 17.9874 25.3248 18.2304 25.2664C18.2304 25.2664 19.2584 24.8832 19.6309 24.7112C19.707 24.681 19.7752 24.6341 19.8306 24.5741C19.886 24.5141 19.9271 24.4425 19.9508 24.3645C20.0539 23.8578 20.0628 23.3366 19.977 22.8267C19.977 22.8267 19.6046 21.5234 19.366 20.8274C19.148 20.6889 18.9935 20.4708 18.9359 20.2201C18.9359 20.2201 18.6212 19.2818 18.5635 19.1358C18.5635 19.1358 18.511 18.7005 18.7523 18.7318C18.7523 18.7318 18.4297 17.7752 18.6448 17.0506C18.6448 17.0506 19.1509 14.9653 20.1659 14.2407C20.1659 14.2407 21.11 13.6855 22.0017 13.7611C22.5643 13.8049 23.1108 13.9685 23.6041 14.2407C24.6164 14.9653 25.1226 17.0506 25.1226 17.0506C25.3376 17.7752 25.0151 18.7318 25.0151 18.7318C25.2563 18.7005 25.2039 19.1358 25.2039 19.1358C25.1488 19.2818 24.8315 20.2071 24.8315 20.2071C24.7713 20.4595 24.6128 20.6779 24.3909 20.8144C24.1575 21.5234 23.7851 22.8267 23.7851 22.8267C23.6993 23.3366 23.7082 23.8578 23.8113 24.3645C23.8364 24.4398 23.8778 24.5087 23.9327 24.5664C23.9875 24.624 24.0544 24.669 24.1286 24.6981C24.501 24.8702 25.5291 25.2533 25.5291 25.2533C25.7721 25.3117 26.0256 25.3117 26.2687 25.2533C27.3167 25.0775 28.3828 25.0329 29.442 25.1204C29.7358 24.9484 30.0269 24.779 30.3101 24.5991C29.7856 23.0821 29.1929 21.539 28.5241 19.9855C27.1365 16.7284 25.4712 13.5952 23.5464 10.6202ZM16.864 3.09514C16.0149 3.6687 15.1099 4.15597 14.1627 4.54959C12.9452 5.0968 11.6518 5.45882 10.3259 5.62349C9.91148 8.01629 10.1501 11.3005 10.9474 15.007C13.4463 14.5565 15.8847 13.8219 18.2146 12.8175C19.9643 12.0768 21.6494 11.1936 23.2527 10.1771C21.1336 7.01798 18.9228 4.54177 16.864 3.09514ZM38.5529 17.5875C38.4061 17.207 38.2513 16.8238 38.0887 16.4458C36.0825 11.7827 33.0376 7.89639 29.4971 5.20383C28.3825 6.91633 26.4785 8.70442 23.9896 10.3387C25.9325 13.3438 27.6136 16.5084 29.0145 19.7979C29.6702 21.3227 30.255 22.8397 30.7717 24.3332C34.1234 22.2245 36.8063 19.8787 38.5529 17.5875ZM4.00013 15.4241C3.43788 18.9917 3.75833 22.6418 4.93378 26.0588L5.4583 25.9988C6.21623 25.9232 7.37018 25.8893 7.37018 25.8893C8.27236 25.8893 9.88526 25.9415 9.88526 25.9415C10.6502 25.9256 11.4099 25.8126 12.1459 25.6052C12.6278 25.4221 13.1281 25.291 13.6382 25.2142C12.3355 22.0969 11.2934 18.8783 10.5225 15.5909C7.98911 15.9741 5.71794 15.9297 4.00013 15.4241ZM41.7892 13.9253C41.624 13.5369 41.4457 13.159 41.2647 12.7863C41.0995 14.3033 40.3547 15.9532 39.1299 17.6292C40.1799 20.4055 40.7989 23.3243 40.9657 26.2855C41.697 26.4261 42.4377 26.5132 43.1818 26.5462C43.991 22.2952 43.5061 17.901 41.7892 13.9253V13.9253ZM30.9474 24.8337L31.2097 25.4593C31.3513 25.5036 31.4929 25.5505 31.6319 25.6052C32.3615 25.8155 33.1149 25.9328 33.8742 25.9545C33.8742 25.9545 35.4871 25.9128 36.3867 25.9024C36.3867 25.9024 37.5432 25.9363 38.2986 26.0118C38.2986 26.0118 39.421 26.1422 40.4412 26.2412C40.5514 24.5522 40.1108 21.9039 38.747 18.1427C36.9453 20.4234 34.2571 22.7485 30.9474 24.8337ZM3.55691 14.7203H3.58052C4.13389 11.4074 5.39011 8.40727 7.32035 6.00143C4.96004 8.05154 3.07253 10.5836 1.78665 13.4249C2.23719 14.0188 2.85247 14.4691 3.55691 14.7203V14.7203ZM30.061 2.35749C26.9344 1.05539 23.5456 0.494944 20.1632 0.720583C23.3418 1.07507 26.489 2.38356 29.345 4.44272C29.7281 3.80521 29.972 3.09476 30.061 2.35749V2.35749ZM3.49397 15.2677L3.36022 15.2182C2.66248 14.9545 2.04093 14.5238 1.55062 13.9644C0.102942 17.4077 -0.38224 22.5087 0.31275 26.554C1.18856 26.5337 2.06087 26.4369 2.91962 26.2647C3.40218 26.2204 3.94768 26.1656 4.40926 26.1161C3.17926 22.2245 3.02977 19.2557 3.49397 15.2677ZM10.4124 15.0957C9.62562 11.397 9.38172 8.11534 9.78822 5.64694C9.51044 5.64982 9.23432 5.60394 8.97259 5.5114C8.85351 5.46076 8.74567 5.38724 8.65526 5.29506C6.23984 7.79734 4.70299 11.1441 4.0893 14.9002C5.72843 15.4084 7.93404 15.458 10.4124 15.0826V15.0957ZM17.3099 2.76932C19.3738 4.26287 21.5795 6.74951 23.6906 9.8956C26.1244 8.28998 27.9996 6.53838 29.0722 4.88844C25.8254 2.53474 22.1879 1.19237 18.5635 1.14545C18.5407 1.25757 18.5055 1.36685 18.4586 1.47127C18.1864 1.98956 17.7923 2.43486 17.3099 2.76932V2.76932ZM9.17978 5.01356C9.83805 5.27421 11.6975 5.03701 13.9765 4.06738C14.9987 3.64746 15.967 3.10849 16.8614 2.46175V2.46175C17.4672 2.00561 17.8527 1.59117 17.976 1.2862C18.0159 1.20527 18.0253 1.11274 18.0022 1.02555C17.9952 1.01537 17.9873 1.00578 17.9786 0.996877C16.2973 1.27555 14.6547 1.74972 13.0848 2.40962C11.624 3.03268 10.2356 3.81137 8.94374 4.73205C8.93397 4.76966 8.93397 4.80912 8.94374 4.84674C8.96941 4.8892 9.00362 4.92593 9.04424 4.95464C9.08485 4.98334 9.131 5.0034 9.17978 5.01356V5.01356Z"
                            fill="#006397"
                          />
                          <path
                            d="M16.3024 35.2278C16.1136 33.5674 15.8461 31.1068 15.8461 31.1068C15.6805 30.3739 15.2432 29.7299 14.6213 29.3031C14.1545 28.9747 12.754 29.0763 12.754 29.0763C11.1936 29.337 9.31317 28.9043 9.31317 28.9043C9.07451 28.8183 8.03334 28.6436 8.03334 28.6436C7.27019 28.5874 6.51362 28.4635 5.77265 28.2735C5.41095 28.2164 5.04527 28.1876 4.67903 28.1875C4.25662 28.2521 3.83122 28.2955 3.40444 28.3178C2.53788 28.46 1.65991 28.5219 0.781836 28.5029C1.54764 30.5881 4.19122 36.7239 9.51511 39.5494L9.85867 38.7049L11.7181 40.8318L8.90142 41.0456L9.29481 40.029C3.90798 37.2009 1.19096 31.1277 0.328125 28.8339V42.9874H16.2028C16.4335 42.2368 16.7561 41.3401 16.7561 41.3401C17.0184 40.5581 16.861 39.4243 16.861 39.4243C16.6224 38.7257 16.3024 35.2278 16.3024 35.2278ZM39.9058 28.3178C39.4782 28.2956 39.0519 28.2521 38.6286 28.1875C38.2624 28.1876 37.8967 28.2164 37.535 28.2735C36.7916 28.4658 36.0324 28.5914 35.2665 28.6489C35.2665 28.6489 34.2174 28.8183 33.9893 28.9095C33.9893 28.9095 32.1088 29.3396 30.5484 29.0815C30.5484 29.0815 29.1479 28.9799 28.6785 29.3083C28.0575 29.736 27.6205 30.3796 27.4537 31.112C27.4537 31.112 27.1915 33.5726 26.9974 35.233C26.9974 35.233 26.6801 38.7205 26.4414 39.4373C26.4414 39.4373 26.2788 40.5816 26.5463 41.3531C26.5463 41.3531 26.8663 42.2498 27.0997 43.0005H29.3945C29.8377 42.8441 30.2756 42.6773 30.7058 42.4922C34.357 40.9492 37.5082 38.4334 39.8114 35.2226L38.7624 34.6595L41.4899 32.775L41.385 36.0619L40.2835 35.4728C37.9205 38.7866 34.6784 41.3836 30.9182 42.9744L30.8552 43.0005H43.1972V28.4951C42.0969 28.5447 40.9943 28.4853 39.9058 28.3178V28.3178Z"
                            fill="#B67A00"
                          />
                          <path
                            d="M60.2333 17.2497C60.2333 14.9209 60.0997 14.3238 58.6712 14.1978L57.6565 14.1049C57.5968 14.0577 57.5485 13.9977 57.5153 13.9293C57.4821 13.861 57.4648 13.786 57.4648 13.7101C57.4648 13.6342 57.4821 13.5593 57.5153 13.491C57.5485 13.4226 57.5968 13.3626 57.6565 13.3154C59.3654 13.1562 61.5216 13.0633 64.4655 13.0566C66.4681 13.0566 68.3639 13.2026 69.8058 13.9258C70.5551 14.2703 71.1846 14.8281 71.6148 15.5284C72.0449 16.2288 72.2564 17.0402 72.2223 17.86C72.2223 20.129 70.8872 21.2967 68.9981 22.1791C68.9981 22.4976 69.2518 22.5905 69.5989 22.6502C70.8201 22.8825 71.9186 23.5382 72.6986 24.5006C73.4787 25.463 73.8894 26.6694 73.8578 27.9047C73.8578 31.5537 71.1409 34.0151 65.4334 34.0284C64.5189 34.0284 62.9635 33.9355 61.6351 33.9355C60.3067 33.9355 59.1652 34.0085 57.9903 34.0417C57.8948 33.9334 57.84 33.7956 57.8351 33.6516C57.8303 33.5077 57.8757 33.3666 57.9636 33.2522L58.5377 33.1593C60.2132 32.874 60.28 32.4958 60.2733 29.2184L60.2333 17.2497ZM62.8367 21.4361C62.8367 22.3184 62.8367 22.3782 64.4855 22.3118C67.7164 22.1791 69.4587 21.237 69.452 18.2714C69.452 15.1863 67.1356 14.0253 64.7258 14.0319C64.2328 14.0029 63.7388 14.0682 63.2706 14.2243C62.9501 14.3172 62.8233 14.4764 62.8233 15.0404L62.8367 21.4361ZM62.8367 28.734C62.8367 29.8685 62.9034 31.4741 63.5042 32.1641C63.8282 32.488 64.2216 32.735 64.655 32.8867C65.0885 33.0383 65.5508 33.0907 66.0075 33.0399C68.8245 33.0399 70.9807 31.7727 70.974 28.6213C70.974 26.1399 69.699 23.2406 64.6591 23.2539C62.9435 23.2539 62.8233 23.4463 62.8233 24.07L62.8367 28.734Z"
                            fill="#005187"
                          />
                          <path
                            d="M88.8648 27.5465C88.8648 31.4875 86.1479 34.3204 82.1894 34.327C81.3254 34.3616 80.4635 34.218 79.6581 33.9052C78.8527 33.5923 78.1212 33.1171 77.5097 32.5094C76.8983 31.9016 76.4201 31.1746 76.1053 30.3742C75.7906 29.5737 75.646 28.7171 75.6809 27.8584C75.6557 26.9666 75.8117 26.0788 76.1397 25.2484C76.4677 24.4179 76.9608 23.6617 77.5896 23.0249C78.2184 22.3882 78.9699 21.8841 79.7993 21.5427C80.6286 21.2013 81.5187 21.0297 82.4164 21.0381C83.2758 21.0232 84.1293 21.1822 84.925 21.5053C85.7208 21.8284 86.4421 22.3089 87.0452 22.9176C87.6483 23.5263 88.1206 24.2506 88.4334 25.0463C88.7462 25.8421 88.893 26.6927 88.8648 27.5465V27.5465ZM82.0425 21.9868C79.9465 21.9868 78.3978 23.9772 78.4044 27.4404C78.4044 30.3065 79.7395 33.4115 82.5031 33.4115C85.2668 33.4115 86.1412 30.5122 86.1412 28.1038C86.1346 25.3903 85.0465 21.9934 82.0425 22.0001V21.9868Z"
                            fill="#005187"
                          />
                          <path
                            d="M102.616 29.2714C102.616 31.7594 102.656 32.9271 103.544 32.9204C104.002 32.8747 104.451 32.7676 104.879 32.602C105.106 32.6683 105.14 33.4578 104.879 33.6104C103.454 33.8243 102.051 34.164 100.687 34.6255C100.494 34.6255 100.34 34.5326 100.333 34.3734V33.8426C100.357 33.5163 100.337 33.1884 100.273 32.8674H100.153C98.7579 33.8095 97.6832 34.3203 96.1478 34.3203C92.6299 34.3203 90.2801 31.5935 90.2734 28.2829C90.2734 23.8776 93.6111 21.038 97.9301 21.0313C98.6485 21.0036 99.3664 21.0978 100.053 21.31C100.213 21.31 100.247 21.1176 100.247 20.8655V16.1085C100.247 14.2509 100.247 14.0651 99.2652 13.5012L98.9448 13.3087C98.8678 13.2216 98.8254 13.1096 98.8254 12.9936C98.8254 12.8776 98.8678 12.7656 98.9448 12.6785C100.119 12.3307 101.262 11.8869 102.363 11.3516C102.429 11.3514 102.493 11.3693 102.55 11.4032C102.606 11.4371 102.652 11.4858 102.683 11.544C102.683 12.4861 102.59 14.0585 102.59 15.4451L102.616 29.2714ZM100.26 24.5543C100.295 24.1172 100.172 23.682 99.9127 23.3269C99.604 22.9126 99.2014 22.5765 98.7374 22.3459C98.2734 22.1154 97.7613 21.9969 97.2426 22C94.3588 22 92.8702 24.4946 92.8769 27.2346C92.8769 30.1008 94.5057 32.8076 97.6097 32.801C98.5006 32.7921 99.3612 32.4781 100.046 31.912C100.24 31.5575 100.317 31.1513 100.267 30.7509L100.26 24.5543Z"
                            fill="#005187"
                          />
                          <path
                            d="M105.292 40.3525C105.279 40.1836 105.302 40.014 105.362 39.8552C105.421 39.6964 105.514 39.5522 105.634 39.4324C105.755 39.3127 105.9 39.2203 106.06 39.1615C106.219 39.1027 106.39 39.079 106.56 39.0919H107.161C107.371 39.0994 107.579 39.0503 107.764 38.9499C107.948 38.8495 108.102 38.7014 108.209 38.5213C108.928 37.417 109.538 36.2461 110.031 35.0249C110.198 34.5995 110.304 34.1528 110.345 33.698C110.304 32.9452 110.121 32.2068 109.804 31.5219L107.361 24.7613C106.82 23.2818 106.593 22.5255 105.485 22.3065L104.691 22.1539C104.497 21.9947 104.531 21.4573 104.784 21.3644C105.792 21.4241 106.747 21.4573 107.795 21.4507C108.649 21.4507 109.537 21.4175 110.552 21.3578C110.799 21.4507 110.832 21.9814 110.612 22.1407L109.824 22.2999C109.377 22.3994 109.123 22.4923 109.123 22.7112C109.36 23.7164 109.663 24.7048 110.031 25.6702L111.046 28.5629C111.301 29.3294 111.611 30.0766 111.974 30.7987C112.425 30.0557 112.813 29.2768 113.135 28.47L114.21 25.9754C114.698 24.9701 115.07 23.9129 115.318 22.824C115.318 22.6051 115.124 22.3861 114.55 22.2933L113.569 22.134C113.349 21.9814 113.382 21.4706 113.636 21.3512C114.651 21.4109 115.598 21.4374 116.426 21.4374C117.254 21.4374 117.941 21.4374 118.829 21.3379C118.889 21.3828 118.939 21.4399 118.976 21.5054C119.012 21.5708 119.034 21.6432 119.041 21.7178C119.047 21.7923 119.037 21.8674 119.012 21.938C118.988 22.0086 118.948 22.0731 118.896 22.1274L118.355 22.2203C117.314 22.4127 116.74 23.3283 115.685 25.5376L113.923 29.1666C112.882 31.2764 110.291 36.7565 108.743 40.1932C108.613 40.6213 108.348 40.9966 107.988 41.2641C107.627 41.5316 107.19 41.6771 106.74 41.6794C106.554 41.7039 106.364 41.6875 106.185 41.6311C106.006 41.5747 105.841 41.4799 105.703 41.3533C105.565 41.2266 105.456 41.0714 105.385 40.8984C105.314 40.7254 105.282 40.5391 105.292 40.3525V40.3525Z"
                            fill="#005187"
                          />
                          <path
                            d="M126.622 29.1C126.622 32.4173 126.695 32.8817 128.531 33.0343L129.546 33.1272C129.733 33.2532 129.673 33.7906 129.486 33.9167C127.677 33.857 126.602 33.8238 125.333 33.8238C124.065 33.8238 122.957 33.8636 120.928 33.93C120.875 33.8786 120.832 33.8173 120.804 33.7495C120.775 33.6817 120.76 33.6088 120.76 33.5352C120.76 33.4616 120.775 33.3887 120.804 33.3209C120.832 33.2531 120.875 33.1918 120.928 33.1404L122.069 33.0476C123.872 32.8817 124.032 32.3841 124.025 29.1067V15.0282C124.025 14.0529 124.025 14.0197 123.077 14.0197H121.308C119.973 14.0197 118.097 14.0197 117.41 14.8092C116.833 15.4628 116.354 16.1958 115.988 16.9854C115.734 17.1778 115.073 17.0384 115.16 16.7664C115.581 15.4793 116.008 13.4823 116.362 12.0758C116.362 11.963 116.862 11.9763 116.963 12.0758C117.149 13.0776 118.197 13.0511 119.633 13.0444H132.47C134.178 13.0444 134.472 12.9781 134.939 12.1554C135.1 12.0957 135.52 12.109 135.507 12.2549C135.38 13.5354 135.106 16.03 135.04 17.0384C135.04 17.3171 134.372 17.2905 134.218 17.1048C134.118 16.3153 133.898 15.1144 133.424 14.8026C132.69 14.2718 131.488 14.0197 129.746 14.0263H127.496C126.542 14.0263 126.575 14.0595 126.582 15.1011L126.622 29.1Z"
                            fill="#005187"
                          />
                          <path
                            d="M138.208 27.2825C138.682 27.1299 138.742 26.8446 138.742 26.3736V24.9206C138.742 23.7596 138.388 22.1805 136.426 22.1872C135.538 22.1872 134.423 22.6317 134.423 23.607C134.423 24.1112 134.363 24.4894 134.109 24.6751C133.58 25.0458 132.954 25.2556 132.307 25.2789C132.247 25.2862 132.186 25.28 132.129 25.2607C132.072 25.2414 132.02 25.2095 131.977 25.1674C131.934 25.1253 131.901 25.074 131.881 25.0175C131.86 24.961 131.853 24.9006 131.86 24.841C131.86 23.2023 135.431 20.9598 137.747 20.9531C140.064 20.9465 141.139 22.2801 141.045 24.6353L140.865 30.1154C140.805 31.5618 141.092 32.8555 142.327 32.8489C142.602 32.8472 142.874 32.7837 143.121 32.6631C143.281 32.5636 143.435 32.4375 143.535 32.4375C143.635 32.4375 143.755 32.6299 143.755 32.8489C143.452 33.2731 143.051 33.6203 142.588 33.8623C142.124 34.1044 141.609 34.2345 141.085 34.2421C140.689 34.2507 140.296 34.1669 139.937 33.9976C139.579 33.8282 139.266 33.578 139.022 33.2668C138.896 33.0744 138.702 32.829 138.515 32.829C138.074 32.9774 137.658 33.1898 137.28 33.4593C136.602 33.9169 135.815 34.1892 134.997 34.2488C134.195 34.2866 133.407 34.0318 132.781 33.5322C132.469 33.2554 132.219 32.9159 132.049 32.5362C131.879 32.1566 131.792 31.7453 131.793 31.3296C131.793 30.1022 132.394 29.3724 134.423 28.6757L138.208 27.2825ZM136.252 32.8555C136.961 32.7915 137.633 32.5163 138.181 32.066C138.562 31.6878 138.562 31.25 138.595 30.5865L138.655 28.7288C138.655 28.3838 138.528 28.3175 138.335 28.3175C137.892 28.374 137.458 28.4809 137.04 28.6359C135.171 29.2994 134.25 29.7439 134.25 30.9713C134.252 31.2271 134.306 31.4798 134.409 31.7143C134.512 31.9488 134.661 32.1603 134.848 32.3361C135.035 32.512 135.256 32.6486 135.497 32.7379C135.738 32.8271 135.995 32.8671 136.252 32.8555V32.8555Z"
                            fill="#005187"
                          />
                          <path
                            d="M148.75 30.2616C148.75 32.5306 148.824 32.8424 149.965 32.995L150.72 33.0879C150.77 33.1427 150.808 33.2071 150.833 33.2772C150.857 33.3473 150.867 33.4216 150.861 33.4955C150.855 33.5695 150.835 33.6415 150.8 33.7071C150.765 33.7728 150.718 33.8308 150.66 33.8774C149.618 33.8177 148.697 33.7845 147.589 33.7912C146.481 33.7978 145.499 33.8243 144.545 33.8907C144.488 33.8434 144.441 33.7854 144.407 33.72C144.373 33.6547 144.352 33.5832 144.346 33.5098C144.34 33.4363 144.348 33.3624 144.371 33.2923C144.393 33.2222 144.43 33.1572 144.478 33.1012L145.206 33.0083C146.381 32.849 146.414 32.5306 146.407 30.2616V16.0305C146.407 14.1728 146.367 13.9871 145.419 13.4165L145.099 13.2307C145.023 13.143 144.982 13.0312 144.982 12.9156C144.982 12.8 145.023 12.6882 145.099 12.6004C146.273 12.252 147.416 11.8082 148.517 11.2735C148.582 11.272 148.647 11.2885 148.703 11.3213C148.76 11.3541 148.806 11.4019 148.837 11.4593C148.804 12.408 148.744 13.9804 148.75 15.367V30.2616Z"
                            fill="#005187"
                          />
                          <path
                            d="M154.088 16.0168C154.088 14.1591 154.048 13.9734 153.1 13.4028L152.779 13.217C152.693 13.128 152.644 13.009 152.644 12.8853C152.644 12.7615 152.693 12.6426 152.779 12.5536C153.953 12.204 155.096 11.7602 156.197 11.2267C156.263 11.2251 156.327 11.2417 156.384 11.2745C156.44 11.3073 156.487 11.355 156.518 11.4124C156.484 12.3612 156.424 13.9336 156.431 15.3202V26.1212C156.431 26.5325 156.464 26.5922 157.005 26.5922C157.672 26.5922 158.307 26.2406 159.154 25.3582L160.456 23.9716C161.337 23.0229 161.557 22.6779 161.557 22.5253C161.557 22.3727 161.404 22.2732 160.89 22.2068L160.129 22.1139C159.842 22.021 159.842 21.4505 160.129 21.3244H160.857C162.538 21.3249 164.218 21.2385 165.89 21.0657C166.117 21.1586 166.15 21.696 165.957 21.8552L164.942 22.041C164.191 22.2369 163.502 22.618 162.939 23.1489C161.704 24.1308 160.63 25.2653 160.062 25.8027C159.675 26.1477 159.648 26.307 159.835 26.5524C160.5 27.4295 161.211 28.271 161.965 29.0736C163.206 30.4535 164.314 31.6809 164.949 32.278C165.424 32.6504 165.996 32.8805 166.597 32.9415L167.045 33.0078C167.265 33.1604 167.232 33.6713 166.978 33.7907C166.063 33.731 164.975 33.6978 163.967 33.7045C162.706 33.7045 161.591 33.7045 160.676 33.804C160.616 33.759 160.566 33.702 160.53 33.6365C160.493 33.571 160.471 33.4986 160.465 33.4241C160.459 33.3495 160.468 33.2745 160.493 33.2039C160.518 33.1333 160.558 33.0688 160.61 33.0145L161.177 32.9216C161.658 32.8552 161.971 32.7955 161.971 32.6031C161.971 32.4107 161.844 32.1918 161.431 31.7207L158.033 27.8263C157.912 27.6858 157.761 27.5732 157.592 27.4964C157.422 27.4197 157.238 27.3805 157.052 27.3818C156.484 27.3818 156.451 27.4813 156.451 28.4565V30.1882C156.451 32.4572 156.524 32.769 157.666 32.9282L158.427 33.0211C158.475 33.0766 158.511 33.141 158.534 33.2106C158.556 33.2802 158.565 33.3536 158.558 33.4265C158.552 33.4993 158.532 33.5703 158.497 33.6351C158.463 33.6999 158.417 33.7573 158.36 33.804C157.319 33.7443 156.397 33.7177 155.289 33.7177C154.181 33.7177 153.2 33.7509 152.245 33.8172C152.187 33.7698 152.14 33.7109 152.107 33.6441C152.073 33.5774 152.054 33.5044 152.051 33.4299C152.048 33.3554 152.061 33.2811 152.088 33.2118C152.116 33.1425 152.158 33.0798 152.212 33.0277L152.913 32.9349C154.081 32.7756 154.114 32.4572 154.108 30.1948L154.088 16.0168Z"
                            fill="#005187"
                          />
                          <path
                            d="M159.474 10.4968H158.453V9.93945H161.123V10.4968H160.095V13.2501H159.488L159.474 10.4968ZM161.891 9.93945H162.839L163.713 12.1753L164.568 9.93945H165.509V13.2567H164.902V10.729L163.967 13.2567H163.433L162.498 10.729V13.2567H161.884L161.891 9.93945Z"
                            fill="#005187"
                          />
                        </svg>
                      </v-card-title>
                      <registerscreen-two-component
                        :FirstName="form.firstName"
                      />
                    </v-card>
                  </v-dialog>
                  <p
                    class="typo__p"
                    v-if="submitStatus === 'ERROR'"
                    style="color: red"
                  >
                    Please fill the form correctly.
                  </p>
                </form>
              </div>
            </div>
            <!----- ------end ----Section for register new user----------------->
          </div>
        </div>
      </v-col>
      <v-col md="7" class="image_section ma-0 pa-0">
        <div class="image_section_div">
          <span
            >“None but ourselves can free our minds.” <br />
            – Bob Marley
          </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import registerimageuploaderComponent from "../../../components/register/registerimageuploader.component.vue";
import { required, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import RegisterscreenTwoComponent from "../../../components/register/registerscreenTwo.component.vue";
import loaderComponent from "../../../components/loader/loader.component.vue";
export default {
  components: {
    registerimageuploaderComponent,
    RegisterscreenTwoComponent,
    loaderComponent,
  },
  mixins: [validationMixin],
  data() {
    return {
      registerscreen2dialog: false,
      loader: false,
      show1: false,
      InvalidUrl: false,
      EmaiAleardyRegisterd: false,
      NewRegisterdUser: false,
      form: {
        firstName: "",
        lastname: "",
        email: "",
        password: "",
        roleId: 0,
        AccountType: 2,
        ProfileImage: {},
      },

      submitStatus: null,
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
      },
      lastname: {
        required,
      },
      firstName: { required },
    },
  },
  mounted() {
    this.$store.dispatch("ValidateCode", this.$route.params.id).then((res) => {
      if (res.data.Data != null) {
        if (!res.data.Status) {
          this.InvalidUrl = true;
        } else {
          if (res.data.Data.IsRegistered) {
            this.form.email = res.data.Data.Email;
            this.EmaiAleardyRegisterd = true;
          } else {
            this.form.email = res.data.Data.Email;
            this.form.roleId = res.data.Data.RoleId;
            this.NewRegisterdUser = true;
          }
        }
      } else {
        this.InvalidUrl = true;
      }
    });
  },
  methods: {
    SetImage(Img) {
      this.form.ProfileImage = Img;
    },
    SetImageFile(Img) {
      this.form.ProfileImageFile = Img;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        var form = new FormData();
        form.append("FirstName", this.form.firstName);
        form.append("LastName", this.form.lastname);
        form.append("Username", this.form.firstName);
        form.append("Email", this.form.email);
        form.append("Password", this.form.password);
        form.append("RoleId", this.form.roleId);
        form.append("AccountType", this.form.AccountType);
        form.append("ProfileImage", this.form.ProfileImage);
        form.append("ProfileImageFile", this.form.ProfileImageFile);

        this.submitStatus = "PENDING";
        this.submitStatus = "OK";
        this.loader = true;
        this.$store.dispatch("SignupUser", form).then(() => {
          this.loader = false;
          this.registerscreen2dialog = true;
        });
        // do your submit logic here
      }
    },
  },
};
</script>

<style scoped>
.password_limit_error {
  font-family: "Quicksand";
  font-size: 12px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.95);
}
.error {
  color: red;
  background-color: transparent !important;
}
.image_section {
  background-origin: content-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  background-image: url(../../../assets/images/registerimageone.png);
}
.image_section_div {
  margin-top: 28vh;
  margin-left: 5vw;
}
.image_section_div > span {
  font-family: "DM Sans";
  font-size: 26px;
  font-style: italic;
  font-weight: 700;
  line-height: 34px;
  color: rgba(0, 53, 89, 1);
}
h1 {
  font-family: "Noto Serif";
  font-size: 24px;
  font-weight: 600;
  line-height: 33px;
  color: rgba(34, 34, 34, 1);
}
.span_one {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.7);
}
.span_two {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.screen_Two_footer {
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 400;
}
</style>
